import { createAxiosInstance } from '~/plugins/axios.plugin';
import { validateQueryParameters } from '~/helpers/verifyQueryParameters';

export class Calendar {
  static SERVICE_NAME = 'calendar';

  constructor() {
    this.client = createAxiosInstance({
      baseURL           : process.env.PLATAFORMA_API,
      useAccessToken    : true,
      addDefaultHeaders : false
    });
  }

  getAllAppointments(params) {
    const queryParams = validateQueryParameters({
      appointmentCategory : params.appointmentCategory,
      courseId            : params.courseId,
      startDate           : params.startDate,
      endDate             : params.endDate
    });

    return this.client.get(`/calendar/appointment?${queryParams}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  getAllCourses(params) {
    const queryParams = validateQueryParameters({
      page       : params.page,
      limit      : params.limit,
      courseName : params.courseName
    });

    return this.client.get(`/calendar/course?${queryParams}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  getAppointmentTypes() {
    return this.client.get(`/calendar/appointment/type`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  getCourseRelatedDetails(params) {
    return this.client.get(`/calendar/appointment/${params.entity}/${params.topicId}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  deleteAppointment({ appointmentId }) {
    return this.client.delete(`/calendar/appointment/${appointmentId}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  getCategories(params = { withoutCategory: true, isToGetOnlyActual: true }) {
    const queryParams = validateQueryParameters({
      ...params,
      appointmentCategory : params.withoutCategory,
      courseId            : params.isToGetOnlyActual
    });

    return this.client.get(`academic/messages/categories?${queryParams}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  saveAppointment({ payload }) {
    return this.client.post(`/calendar/appointment`, payload)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  editAppointment({ id, payload }) {
    return this.client.put(`/calendar/appointment/${id}`, payload)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }
}

export default new Calendar();
